import styled from '@emotion/styled';
import is from '@sindresorhus/is';

import { getSkillIcon } from './helpers/get-skill-icon';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

import type { FunctionComponent } from 'react';

const MosaicGrid = styled.div<{ readonly dimensions: readonly [number, number] }>((properties) => {
    const {
        dimensions: [rows, columns],
    } = properties;

    return {
        columnGap: '0.25rem',
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(1rem, 1fr))`,
        gridTemplateRows: `repeat(${rows}, minmax(1rem, 1fr))`,
        rowGap: '0.25rem',
    };
});

const IconWrapper = styled.div(() => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '100%',
    maxWidth: '100%',
    svg: {
        height: '100%',
        width: '100%',
    },
}));

export const SkillMosaic: FunctionComponent = () => {
    const skillMosaicDimensions = useCompanyOnboardingStore((state) => state.skillMosaicDimensions);
    const employeeHardSoftSkills = useCompanyOnboardingStore((state) => state.employeeHardSoftSkills);
    const employeeLanguageSkills = useCompanyOnboardingStore((state) => state.employeeLanguageSkills);

    if (employeeHardSoftSkills.isNothing && employeeLanguageSkills.isNothing) {
        return;
    }

    const employeeSkills = [...employeeHardSoftSkills.unwrapOr([]), ...employeeLanguageSkills.unwrapOr([])];

    return (
        <MosaicGrid dimensions={skillMosaicDimensions}>
            {employeeSkills.map((skill, index) => {
                const icon = getSkillIcon(skill);

                if (is.null(icon)) {
                    return null;
                }

                return <IconWrapper key={index}>{icon}</IconWrapper>;
            })}
        </MosaicGrid>
    );
};
